import React from 'react'
import { FindSecondChild } from '../../../../utils/FindMenuOption'

const ResetUserPassword = (props) => {
    const { mainPasswordModal, handlePasswordOnChange, passwordValidation, showPasswordModal, handleOnClosePassword, handlePasswordSave, setShowPasswordModal } = { ...props }
    let IsEditAllowed = FindSecondChild('Setup', 'User Management', 'User')?.IsAdd
    return (
        <div className="ms-3 row">
            <p className="text p-2 bg_blue">Reset Password</p>
            <div className="row p-0 m-0">
                <div className="ps-0 col-md-4">
                    <div className={passwordValidation.Password ? "form-group input error position-relative" : "form-group input position-relative"}>
                        <label for="middleName" className='text'>Old Password<span className='req'>*</span></label>

                        <div className='position-relative'>
                            <input
                                type={showPasswordModal.ShowOldPassword ? 'text' : 'password'}
                                className="form-control pe-5"
                                id="Password"
                                name="Password"
                                autoComplete="new-password"
                                value={mainPasswordModal.Password}
                                onChange={handlePasswordOnChange}
                            />
                            <i className={showPasswordModal.ShowOldPassword ? 'icon-Icon-awesome-eye ar-eye-icon fs-12' : "icon-Icon-ionic-md-eye-off ar-eye-icon fs-14"} onClick={() => setShowPasswordModal((prev) => ({ ...prev, ShowOldPassword: !prev['ShowOldPassword'] }))}></i>
                        </div>

                        {passwordValidation.Password}
                    </div>
                </div>
            </div>
            <div className="row ps-0 m-0">
                <div className="ps-0 col-md-4">
                    <div>
                        <div className={passwordValidation.NewPassword ? "form-group input error position-relative" : "form-group input position-relative"}>
                            <label for="middleName" className='text'>New Password<span className='req'>*</span></label>

                            <div className="position-relative">
                                <input
                                    type={showPasswordModal.ShowNewPassword ? 'text' : 'password'}
                                    className="form-control pe-5"
                                    id="NewPassword"
                                    name="NewPassword"
                                    autocomplete="new-password"
                                    value={mainPasswordModal.NewPassword}
                                    onChange={handlePasswordOnChange}
                                    autoComplete="off"
                                />
                                <i className={showPasswordModal.ShowNewPassword ? 'icon-Icon-awesome-eye ar-eye-icon fs-12' : "icon-Icon-ionic-md-eye-off ar-eye-icon fs-14"} onClick={() => setShowPasswordModal((prev) => ({ ...prev, ShowNewPassword: !prev['ShowNewPassword'] }))}></i>
                            </div>

                            {passwordValidation.NewPassword}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row ps-0 m-0">
                <div className="ps-0 col-md-4 ">
                    <div className={passwordValidation.ConfirmPassword || passwordValidation.PasswordMatch ? "form-group input error position-relative" : "form-group input position-relative"}>
                        <label for="middleName" className='text'>Confirm New Password<span className='req'>*</span></label>

                        <div className='position-relative'>
                            <input
                                type={showPasswordModal.ShowConfirmPasswrod ? 'text' : 'password'}
                                className="form-control pe-5"
                                id="ConfirmPassword"
                                name="ConfirmPassword"
                                autocomplete="new-password"
                                value={mainPasswordModal.ConfirmPassword}
                                onChange={handlePasswordOnChange} />
                            <i className={showPasswordModal.ShowConfirmPasswrod ? 'icon-Icon-awesome-eye ar-eye-icon fs-12' : "icon-Icon-ionic-md-eye-off ar-eye-icon fs-14"}
                                onClick={() => setShowPasswordModal((prev) => ({ ...prev, ShowConfirmPasswrod: !prev['ShowConfirmPasswrod'] }))}></i>
                        </div>

                        {passwordValidation.ConfirmPassword}
                        {passwordValidation.PasswordMatch}
                    </div>
                </div>
            </div>
            {passwordValidation?.PasswordStrength && (
                <p className="text-danger fs-12">{passwordValidation.PasswordStrength}</p>
            )}
            <div className="row ps-0 m-0">
                <div className="ps-0 col-md-4 pt-3 mb-5">
                    <button class="btn btn-gray btn-xs no-width text rounded" onClick={handleOnClosePassword}>Cancel</button>
                    <button class={IsEditAllowed ? "btn btn-orange btn-xs no-width text text-light rounded ms-2" : "btn btn-orange btn-xs no-width text text-light rounded ms-2 disabled"} onClick={handlePasswordSave}>Reset</button>
                </div>
            </div>
        </div>
    )
}

export default ResetUserPassword